<template>
  <div class="my_container">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'UnionNav' }">联盟生态</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Union', query: { id: unionId } }">{{unionName}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="">
      <div class="title_top_hr">
        <p>
          <i></i>
          <span class="comment_btn" :class="navTop === '联盟简介' ? 'act' : ''" @click="navTop = '联盟简介'">联盟简介</span>
          <span class="comment_btn" :class="navTop === '组织架构' ? 'act' : ''" @click="navTop = '组织架构'">组织架构</span>
          <el-divider></el-divider>
        </p>
      </div>
    </div>
    <div v-if="navTop === '联盟简介'" class="glag_introduce_box lf">
      <p class="glag_introduce_title">简介</p>
      <div class="glag_introduce_text">
        {{unionContent}}
      </div>
    </div>
    <div v-if="navTop === '组织架构'" class="glag_organizational_box lf">
      <div class="glag_organizational_nav">
        <div v-for="(item, index) in unionNavList"
        :key="item.id"
        :class="currentNav === item.id ? 'glag_organizational_nav_item act' : 'glag_organizational_nav_item'"
        @click="organizationalClick(index, item.id)">
          <i></i>
          {{item.framework_name}}
        </div>
      </div>
      <ul v-if="unionUserList.length > 0" class="glag_organizational_info">
        <li v-for="item in unionUserList" :key="item.id" class="glag_organizational_info_item">
          <a href="">
            <dl>
              <dt><img :src="item.user_avatar" alt="头像"></dt>
              <dd>{{item.user_name}}</dd>
            </dl>
          </a>
        </li>
      </ul>
      <div v-else class="glag_organizational_info_none">
        暂无成员
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      unionId: '', // 联盟id
      unionType: '', // 类型
      unionName: '', // 联盟名称
      unionContent: '', // 联盟简介
      currentNav: '', // 当前选中导航项
      unionNavList: [], // 联盟组织架构
      unionUserList: [], // 选中组织架构成员
      navTop: ''
    }
  },
  created () {
    this.unionId = this.$route.query.id
    this.unionType = this.$route.query.type
    console.log(this.unionType)
    if (this.unionType === 'organizational') {
      this.navTop = '组织架构'
    } else {
      this.navTop = '联盟简介'
    }
    this.getInfo()
  },
  methods: {
    // 获取联盟基本信息
    getInfo () {
      const vueThat = this
      vueThat.myApi.unionFramework({ union_id: vueThat.unionId }).then((res) => {
        console.log(res)
        if (res.data.code === 200) {
          vueThat.unionName = res.data.data.introduce.union_name
          vueThat.unionContent = res.data.data.introduce.content
          vueThat.unionNavList = res.data.data.organizational
          vueThat.currentNav = vueThat.unionNavList[0].id
          vueThat.unionUserList = vueThat.unionNavList[0].users
        }
      })
    },
    // 切换组织架构
    organizationalClick (index, id) {
      this.unionUserList = this.unionNavList[index].users
      this.currentNav = id
      console.log(this.currentNav)
    }
  }
}
</script>

<style>
</style>
